// extracted by mini-css-extract-plugin
export default {"appleImageBox":"StoreButton-module__appleImageBox--JXE4j","googleImageBox":"StoreButton-module__googleImageBox--hrpsF"};